function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{fill:url(#Sfumatura_senza_nome_13);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sfumatura_senza_nome_13",
  y1: 190.91,
  x2: 98.24,
  y2: 190.91,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0b274b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#192b59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#252f65"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#293069"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Risorsa 21");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2",
  "data-name": "Livello 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Livello_1-2",
  "data-name": "Livello 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M801.52,1305.67c-79.33-69.46-200.33-61.43-269.69,17.75-.65.72-1.23,1.47-1.92,2.39a18,18,0,0,0,27.52,23.08c.45-.52.86-1.06,1.33-1.69,56.41-64.41,154.69-70.9,219.09-14.5A154.07,154.07,0,0,1,823,1401.25h37.58A189.72,189.72,0,0,0,801.52,1305.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M906.84,656.34q49.35-24.68,75.9-67.25t26.53-98.1q0-219.64-234.46-219.66h-311q-32.1,0-53.67,21.59T388.57,346.6v713.26q0,32.1,21.59,53.68t53.67,21.59H771.1q116,0,199.92-58t83.9-204.84q0-83.89-41.34-137T906.84,656.34ZM549,416.94H752.6q45.63,0,70.95,25.3t25.3,75.89q0,42-27.77,66.64T756.3,609.45H549ZM861.8,962.37q-32.71,30.87-90.7,30.86H549V755.06H762.46q55.54,0,93.79,22.21t38.25,95Q894.5,931.53,861.8,962.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M13.61,452.28l176.48-95.45a18,18,0,0,0,7.26-24.35L101.91,156a18,18,0,0,0-24.35-7.25L0,190.67c0,.16,0,.32,0,.48v40.37l78.85-42.63L157.2,333.77,12.32,412.13,0,389.36V453.7a17.52,17.52,0,0,0,5.06.75A18,18,0,0,0,13.61,452.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M158.1,1051.61l-28.54-20.4,20.31-28.67a10.77,10.77,0,1,0-17.58-12.46L112,1018.68,83.56,998.34A10.78,10.78,0,0,0,71,1015.89l28.53,20.39L79.23,1065a10.77,10.77,0,1,0,17.58,12.46l20.28-28.62,28.47,20.35a10.78,10.78,0,0,0,12.54-17.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1277.32,161a18,18,0,0,0-23.3-10.75l-161.1,61.2-56.8-158.89a18,18,0,0,0-23.3-10.74L834.58,109.49a18,18,0,1,0,12.76,33.58L1008.45,81.9l56.8,158.88a18,18,0,0,0,23.3,10.75l161.1-61.19,56.78,158.86a18,18,0,0,0,33.84-12.1Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "157.2 333.77 78.85 188.89 0 231.52 0 389.36 12.32 412.13 157.2 333.77"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M856.25,777.27Q818,755.06,762.46,755.06H549V993.23H771.1q58,0,90.7-30.86t32.7-90.08Q894.5,799.5,856.25,777.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M0,190.67v.48c0-.16,0-.32,0-.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M821.08,584.77q27.76-24.67,27.77-66.64,0-50.58-25.3-75.89t-70.95-25.3H549V609.45H756.3Q793.32,609.45,821.08,584.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M1251.91,1212.82a26.29,26.29,0,0,0-20.26,1.32,26.86,26.86,0,0,0-12.14,35.84,26.55,26.55,0,0,0,35.6,12.2,26.84,26.84,0,0,0,12.1-35.85A26.44,26.44,0,0,0,1251.91,1212.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M1210.1,0H191.15C85.74,0,.27,85.32,0,190.67l77.55-41.93A18,18,0,0,1,101.91,156l95.44,176.49a18,18,0,0,1-7.26,24.35L13.61,452.28a18,18,0,0,1-8.55,2.17A17.52,17.52,0,0,1,0,453.7v756.4c0,105.57,85.58,191.15,191.15,191.15H823a154.07,154.07,0,0,0-45.15-68.55c-64.4-56.4-162.68-49.91-219.09,14.5-.47.63-.88,1.17-1.33,1.69a18,18,0,0,1-27.52-23.08c.69-.92,1.27-1.67,1.92-2.39,69.36-79.18,190.36-87.21,269.69-17.75a189.72,189.72,0,0,1,59.06,95.58H1210.1c105.57,0,191.15-85.58,191.15-191.15V191.15C1401.25,85.58,1315.67,0,1210.1,0ZM160.6,1066.65a10.8,10.8,0,0,1-15,2.51l-28.47-20.35-20.28,28.62A10.77,10.77,0,0,1,79.23,1065l20.32-28.69L71,1015.89a10.78,10.78,0,0,1,12.54-17.55L112,1018.68l20.27-28.6a10.77,10.77,0,1,1,17.58,12.46l-20.31,28.67,28.54,20.4A10.79,10.79,0,0,1,160.6,1066.65ZM971,1077.13q-83.94,58-199.92,58H463.83q-32.1,0-53.67-21.59t-21.59-53.68V346.6q0-32.07,21.59-53.68t53.67-21.59h311q234.44,0,234.46,219.66,0,55.51-26.53,98.1t-75.9,67.25q65.4,25.92,106.74,79t41.34,137Q1054.92,1019.16,971,1077.13Zm293.64,204.37h0a48.09,48.09,0,0,1-64.49-22,48.44,48.44,0,0,1,21.93-64.65,48.08,48.08,0,0,1,64.48,22A48.43,48.43,0,0,1,1264.66,1281.5Zm64.74-921.43a18,18,0,0,1-23-10.87l-56.78-158.86-161.1,61.19a18,18,0,0,1-23.3-10.75L1008.45,81.9,847.34,143.07a18,18,0,1,1-12.76-33.58l178.24-67.68a18,18,0,0,1,23.3,10.74l56.8,158.89,161.1-61.2a18,18,0,0,1,23.3,10.75l63,176.11A18,18,0,0,1,1329.4,360.07Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12.32 412.13 157.2 333.77 78.85 188.89 0 231.52 0 389.36 12.32 412.13"
})));

var SvgLogoIcon = function SvgLogoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1401.25 1401.25",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-icon.c657fb57.svg";
export { ForwardRef as ReactComponent };